// Session status, attendee status, and certificate status badge components
import { Badge } from '@/ui/badge'
import { cn } from '@/core/lib/utils'
import type { ClassSession, SessionAttendee } from '@/features/classes/stores'

import { STATUS_BADGE } from '../utils/formatters'

export function SessionStatusBadge({ status }: { status: ClassSession['status'] }) {
  const cfg = STATUS_BADGE[status]
  if (!cfg) {
    return (
      <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-gray-100 text-gray-500 border border-gray-200">
        {status ?? 'Unknown'}
      </span>
    )
  }
  return (
    <span className={cn('text-xs font-medium px-2.5 py-1 rounded-full', cfg.className)}>
      {cfg.label}
    </span>
  )
}

export function AttendeeStatusBadge({ status }: { status: SessionAttendee['status'] }) {
  if (status === 'completed') {return <Badge variant="success">Completed</Badge>}
  if (status === 'paid') {return <Badge variant="default">Paid</Badge>}
  if (status === 'quiz-completed') {return <Badge variant="default">Diagnostic Ready</Badge>}
  if (status === 'pending') {return <Badge variant="warning">Pending</Badge>}
  return <Badge variant="outline">Registered</Badge>
}

export function CertStatusBadge({ status }: { status: 'valid' | 'expired' | 'revoked' }) {
  if (status === 'valid') {return <Badge variant="success">Valid</Badge>}
  if (status === 'expired') {return <Badge variant="warning">Expired</Badge>}
  return <Badge variant="destructive">Revoked</Badge>
}
